function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgFilter(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 96 96",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    d: "M77.541 15.421a4.003 4.003 0 00-3.561-2.177H22.019a4.003 4.003 0 00-3.246 6.339L44 54.582v27.085c0 2.209 7.875 7.771 7.958 3.666L52 54.582l25.226-34.999c.878-1.218 1-2.825.315-4.162z"
  }));
}

SvgFilter.clsName = 'icon-www__filter';
SvgFilter.remarkName = 'unknown';
export default SvgFilter;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Filter.js
// module id = 2346
// module chunks = 17 18